module.exports = __webpack_public_path__ + "img/ring_g_c_1_null@3x.ead4c6aa.png";